<template>
  <div>
    <b-modal
        scrollable
      id="add-color-direct"
      ref="modal"
      header-class="headerModal"
      centered
      :title="`${$t('AddColor')} - ${articleName}`"
      hide-footer
      @hide="onCancel"
    >
      <b-form-group
        :label="$t('ColorName')"
      >
        <b-form-input
          v-model="colorName"
          :placeholder="$t('ColorName')"
        />
      </b-form-group>
      <div class="buttonsEverywhere">
        <b-button
          type="button"
          variant="none"
          class="buttonSubmit"
          style="background: #FF274F !important;"

          @click="onSubmit"
        >
          {{ $t('Submit') }}
        </b-button>
        <b-button
          type="button"
          variant="danger"
          class="buttonCancel"
          style="margin-right: 15px; ; background: white; color: black; border-color: white;font-weight: 400;"

          @click="onCancel"
        >
          {{ $t('Cancel') }}
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  props: ['articleId', 'articleName'],
  data() {
    return {
      colorName: null,
    }
  },
  computed: {
    ...mapGetters([]),
  },
  mounted() {

  },
  methods: {
    ...mapActions([]),
    onSubmit() {
      const object = {
        colorName: this.colorName,
        mainDressCategoryId: this.articleId,
        fileName: [],
        articleName: this.articleName,
      }
      this.$emit('addColor', object)
      this.onReset()
    },
    onCancel() {
      this.onReset()
    },
    onReset() {
      this.colorName = null
      this.$refs.modal.hide()
    },
  },
}
</script>

    <style lang="scss" scoped>

    </style>
